import { checkIsDefined } from "@/shared/Preconditions";
import { getValue } from "@/shared/RxUtil";
const UNAUTHENTICATED_ERROR = "Authentication is required for updating profile";
export class UpdateProfileUseCaseImpl {
    constructor(userRepository, authRepository) {
        this.userRepository = userRepository;
        this.authRepository = authRepository;
    }
    async run(update) {
        const userId = await getValue(this.authRepository.userId);
        checkIsDefined(userId, UNAUTHENTICATED_ERROR);
        return this.userRepository.updateUser(userId, update);
    }
}
